import { render, staticRenderFns } from "./MedicalReports.vue?vue&type=template&id=6d5233c0"
import script from "./MedicalReports.vue?vue&type=script&lang=js"
export * from "./MedicalReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports